import { Select } from "antd";
import { MdArrowDropDown } from "react-icons/md";

const Budget = ({ options, value, onChange, translate }) => {
  return (
    <div className="acoris-budget">
      <span className="acoris-budget__badge">
        {translate?.BUDGET?.TAG || "À renseigner"}
      </span>
      <div className="acoris-budget__content">
        <p className="acoris-budget__title">
          {translate?.BUDGET?.TITLE || "Quel est votre budget mensuel ?"}
        </p>
        <p className="acoris-budget__subtitle">
          {translate?.BUDGET?.SUBTITLE ||
            "Nécessaire pour vous proposer une offre adaptée."}
        </p>
      </div>
      <Select
        placeholder={
          translate?.BUDGET?.PLACEHOLDER || "Sélectionnez un intervalle"
        }
        options={options}
        value={value}
        onChange={(e) => onChange(e)}
        className="acoris-budget__select"
        suffixIcon={<MdArrowDropDown className="acoris-budget__arrow" />}
        popupMatchSelectWidth={false}
      />
    </div>
  );
};

export default Budget;
